import { Pipe, PipeTransform } from '@angular/core';
/**
 * Solution for Myorders page/ImportOrder list page/OrderStatus page where Orderplace date is either entryDtm or OrderDate.
 * OrderDate is always have 0 offset and time starts at midnight. But CDC entryDtm has time and offset aswell.
 * In order to sync between two date source, we need to exclude time andzones while converting dates to GMT in template.
 * This is display purpose only and will not affect actual object in class/state
 */
@Pipe({
  name: 'formatDateWithZeroOffset',
})
export class FormatDateWithZeroOffsetPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return null;

    const date = new Date(value);
    const formattedDate = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
    );

    return formattedDate.toISOString().slice(0, 10) + 'T00:00:00Z'; //set time to midnight
  }
}
